/* tslint:disable */
/* eslint-disable */
import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse } from '@angular/common/http';
import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';
import { RequestBuilder } from '../request-builder';
import { Observable } from 'rxjs';
import { map, filter } from 'rxjs/operators';

import { MethodResultDto } from '../models/method-result-dto';

@Injectable({
  providedIn: 'root',
})
export class DeviceTunnelControllerService extends BaseService {
  constructor(
    config: ApiConfiguration,
    http: HttpClient
  ) {
    super(config, http);
  }

  /**
   * Path part for operation getProtocols
   */
  static readonly GetProtocolsPath = '/api/v1/protocols';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getProtocols()` instead.
   *
   * This method doesn't expect any request body.
   */
  getProtocols$Response(params?: {
  }): Observable<StrictHttpResponse<Array<{  }>>> {

    const rb = new RequestBuilder(this.rootUrl, DeviceTunnelControllerService.GetProtocolsPath, 'patch');
    if (params) {
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Array<{  }>>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `getProtocols$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getProtocols(params?: {
  }): Observable<Array<{  }>> {

    return this.getProtocols$Response(params).pipe(
      map((r: StrictHttpResponse<Array<{  }>>) => r.body as Array<{  }>)
    );
  }

  /**
   * Path part for operation invokeDeviceTunneling
   */
  static readonly InvokeDeviceTunnelingPath = '/api/v1/device/{deviceId}/tunnel';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `invokeDeviceTunneling()` instead.
   *
   * This method doesn't expect any request body.
   */
  invokeDeviceTunneling$Response(params: {
    deviceId: string;
  }): Observable<StrictHttpResponse<MethodResultDto>> {

    const rb = new RequestBuilder(this.rootUrl, DeviceTunnelControllerService.InvokeDeviceTunnelingPath, 'patch');
    if (params) {
      rb.path('deviceId', params.deviceId, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<MethodResultDto>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `invokeDeviceTunneling$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  invokeDeviceTunneling(params: {
    deviceId: string;
  }): Observable<MethodResultDto> {

    return this.invokeDeviceTunneling$Response(params).pipe(
      map((r: StrictHttpResponse<MethodResultDto>) => r.body as MethodResultDto)
    );
  }

}
